

export default {
    props: {
        init_data: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    created() {
        for (let k in this.init_data){
            this.$data[k] = this.init_data[k];
        }
    },
    methods: {
        save_data : function(){
            this.$emit('input', this.$data)
        },
        notify_parent : function(){
            this.save_data()
        },
    }        

}


